export default "__VITE_ASSET__8gLWBlbk__"